module.exports = __webpack_public_path__ + "img/admin-empresas.2b062418.svg";